import {
  ChartIcon,
  CogInHomeIcon,
  PeopleIcon,
  PersonInHomeIcon,
  ReportIcon,
} from '../components/icons';
import { ReportType } from '../types';

export const MARKET_OPTIONS = [
  { value: 'Los Angeles', label: 'Los Angeles' },
  { value: 'Tucson', label: 'Tucson' },
  { value: 'Riverside', label: 'Riverside' },
  { value: 'Denver', label: 'Denver' },
  { value: 'Charlotte', label: 'Charlotte' },
  { value: 'Minneapolis', label: 'Minneapolis' },
  { value: 'Austin', label: 'Austin' },
  { value: 'Atlanta', label: 'Atlanta' },
  { value: 'Nashville', label: 'Nashville' },
  { value: 'Phoenix', label: 'Phoenix' },
  { value: 'Tampa', label: 'Tampa' },
  { value: 'Houston', label: 'Houston' },
  { value: 'San Antonio', label: 'San Antonio' },
  { value: 'Portland', label: 'Portland' },
  { value: 'Jacksonville', label: 'Jacksonville' },
  { value: 'Sacramento', label: 'Sacramento' },
  { value: 'Las Vegas', label: 'Las Vegas' },
  { value: 'Dallas', label: 'Dallas' },
  { value: 'Raleigh', label: 'Raleigh' },
  { value: 'Orlando', label: 'Orlando' },
  { value: 'Salt Lake City', label: 'Salt Lake City' },
  { value: 'San Diego Ca', label: 'San Diego, CA' },
  { value: 'Asheville Nc', label: 'Asheville, NC' },
  { value: 'Boise', label: 'Boise' },
  { value: 'Prescott Az', label: 'Prescott, AZ' },
  { value: 'Greensboro Nc', label: 'Greensboro, NC' },
  { value: 'Killeen Tx', label: 'Killeen, TX' },
  { value: 'St Louis', label: 'St. Louis' },
  { value: 'Greenville Sc', label: 'Greenville-Anderson, SC' },
  { value: 'Corpus Christi Tx', label: 'Corpus Christi, TX' },
  { value: 'Northern Colorado Co', label: 'Northern Colorado, CO' },
  { value: 'Colorado Springs Co', label: 'Colorado Springs, CO' },
  { value: 'Kansas City', label: 'Kansas City' },
  { value: 'Miami Fl', label: 'Miami, FL' },
  { value: 'Oklahoma City Ok', label: 'Oklahoma City, OK' },
  { value: 'Columbia Sc', label: 'Columbia, SC' },
  { value: 'Reno Nv', label: 'Reno, NV' },
  { value: 'Knoxville Tn', label: 'Knoxville, TN' },
  { value: 'Chattanooga', label: 'Chattanooga' },
  { value: 'Indianapolis In', label: 'Indianapolis, IN' },
  { value: 'Birmingham Al', label: 'Birmingham, AL' },
  { value: 'Columbus Oh', label: 'Columbus, OH' },
  { value: 'Washington Dc', label: 'Washington, DC' },
  { value: 'Cleveland Oh', label: 'Cleveland, OH' },
  { value: 'New York New Jersey', label: 'New York / New Jersey' },
  { value: 'Southwest Fl', label: 'Southwest FL' },
  { value: 'Detroit Mi', label: 'Detroit, MI' },
  { value: 'Sf Bay Area', label: 'SF Bay Area' },
  { value: 'Albuquerque Nm', label: 'Albuquerque, NM' },
  { value: 'Boston Ma', label: 'Boston, MA' },
  { value: 'Cincinnati Oh', label: 'Cincinnati, OH' },
  { value: 'Charleston Sc', label: 'Charleston, SC' },
  { value: 'Richmond Va', label: 'Richmond, VA' },
].sort((a, b) => (a.value < b.value ? -1 : 1));

export const DATE_OPTIONS = [
  { value: 'last30', label: 'Last 30 Days' },
  { value: 'last90', label: 'Last 90 Days' },
  { value: 'lastyear', label: 'Last 12 months' },
  { value: 'last2years', label: 'Last 24 months' },
  { value: 'monthToDate', label: 'Month to Date' },
  { value: 'yearToDate', label: 'Year to Date' },
  { value: 'sinceInception', label: 'Since Inception' },
];

/*
  Establishes constant report display types. This is useful for
  building csv download links on the fly because we only want to have
  download capability for reports that are TABLE displays (according to Luke)

  Use of integers is arbitrary.
*/
export enum ReportDisplay {
  TABLE = 0,
  CHART,
  MISC,
  HIDDEN,
}

export const SUMMARY: ReportType = {
  displayType: ReportDisplay.MISC,
  sectionId: 'summary-section',
  loadStateLabel: 'summaryLoaded',
  iconText: 'Summary',
  navIcon: <ReportIcon />,
};

export const CHARTS: ReportType = {
  displayType: ReportDisplay.CHART,
  sectionId: 'charts-section',
  loadStateLabel: 'chartsLoaded',
  iconText: 'Charts',
  navIcon: <ChartIcon />,
};

export const SALES: ReportType = {
  displayType: ReportDisplay.TABLE,
  sectionId: 'sales-associates-section',
  loadStateLabel: 'salesLoaded',
  iconText: 'Sales Associates',
  navIcon: <PeopleIcon />,
};

export const CUSTOMERS: ReportType = {
  displayType: ReportDisplay.TABLE,
  sectionId: 'customers-section',
  loadStateLabel: 'customersLoaded',
  iconText: 'Customers',
  navIcon: <PersonInHomeIcon />,
};

export const CUSTOMERS_FULL: ReportType = {
  displayType: ReportDisplay.HIDDEN,
  sectionId: '',
  loadStateLabel: 'customersFullLoaded',
  iconText: '',
  navIcon: null,
};

export const SALES_FULL: ReportType = {
  displayType: ReportDisplay.HIDDEN,
  sectionId: '',
  loadStateLabel: 'salesFullLoaded',
  iconText: '',
  navIcon: null,
};

export const ADDRESSES: ReportType = {
  displayType: ReportDisplay.MISC,
  sectionId: 'address-section',
  loadStateLabel: 'addressLoaded',
  iconText: 'Addresses',
  navIcon: <CogInHomeIcon />,
};

export const reportConfigMap = new Map([
  ['summary', SUMMARY],
  ['charts', CHARTS],
  ['sales', SALES],
  ['customers', CUSTOMERS],
  ['customers-full', CUSTOMERS_FULL],
  ['sales-full', SALES_FULL],
  ['addresses', ADDRESSES],
]);
